// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'

import store from './store'
import api from './api'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(api)

Vue.prototype.$err400 = function handle400 (err, errorDict = null) {
  let errDict = errorDict || this.errors
  if (!errDict) throw new Error('Error dict is not found.')
  Object.keys(errDict).forEach(k => {
    errDict[k] = []
  })
  if (err.status === 400) {
    let body = err.response.body
    Object.keys(body).forEach(k => {
      errDict[k] = body[k]
    })
    return true
  }
  errDict.nonFieldErrors = [err.response.statusText]
  return false
}

router.beforeEach((to, from, next) => {
  let shopSelect = async function () {
    if (to.params && to.params.shopId) {
      // await store.dispatch('setShopDataById', to.params.shopId)
    }
    if (to.matched.some(record => record.meta.shopRequired === true)) {
      let shopData = store.getters['shopData']
      if (!shopData || !shopData.pk) {
        next({name: 'index'})
      } else {
        next()
      }
    } else {
      next()
    }
  }
  const requireAdmin = function () {
    return new Promise((resolve, reject) => {
      if (to.matched.some(record => record.meta.requireAdmin === true)) {
        if (!store.getters['isLoggedIn']) {
          store.dispatch('tryLoggedIn').then(res => {
            if (store.getters['isStaff']) {
              resolve()
            }
          }, () => {
            reject(new Error('staff perm required'))
          })
        } else if (store.getters['isStaff']) {
          resolve()
        } else {
          reject(new Error('staff perm required'))
        }
      } else {
        resolve()
      }
    })
  }
  const requireAuth = function () {
    return new Promise((resolve, reject) => {
      if (to.matched.some(record => record.meta.noAuth === true)) {
        resolve()
      } else {
        if (!store.getters['isLoggedIn']) {
          store.dispatch('tryLoggedIn').then(() => {
            resolve()
          }, () => {
            reject(new Error('tryLoggedIn failed'))
          })
        } else {
          resolve()
        }
      }
    })
  }

  requireAuth().then(requireAdmin).then(() => {
    shopSelect()
  }).catch(() => {
    next({name: 'Login'})
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js